
import React from 'react'
import Button from '@material-ui/core/Button';
import Papa from 'papaparse'

const ContactListExportButton = props => {

    function convertToCSV(arr) {
        for (let contact of arr) {
            delete contact.ContactListContact
            delete contact.createdAt
            delete contact.updatedAt
            delete contact.org_id
            delete contact.id
        }

        var papaCSV = Papa.unparse({
            fields: ['firstName', 'lastName', 'phone', 'email'],
            data: arr
          });

        var downloadLink = document.createElement("a");
        var blob = new Blob(["\ufeff", papaCSV]);
        var url = URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download = `${props.data.name}.csv`;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }

    return (
        <Button
            style={{
                fontSize: '10',
                color: "#03a9f4",
            }} onClick={() => convertToCSV(props.data.Contacts)}>
            Export
        </Button>
    );
}

export default ContactListExportButton